import React from 'react';
import { Line } from '@ant-design/charts';
import StatisticsCard from '../../../layouts/statistics/statistics-card/StatisticsCard';
import { statisticsDataKeys } from '../../../layouts/analytics/Analytics';
import moment from 'moment';
import '../Chart.scss';
function CustomLineChart(props) {
  const {
    data = [],
    tooltipItems = [],
    includeCard = false,
    title = null,
    additionalData = [],
    xAxis = 'x',
    yAxis = 'y',
  } = props;
  const config = {
    data,
    xField: xAxis,
    yField: yAxis,
    axis: {
      x: {
        labelFormatter: (value) =>
          xAxis?.toUpperCase() === 'DATE'
            ? moment(value)?.format(statisticsDataKeys.dateMonthFormat)
            : value,
      },
      y: {
        tickCount: 5,
        labelFormatter: (value) => {
          const intValue = parseInt(value);
          return intValue === value ? intValue : '';
        },
      },
    },
    point: {
      shapeField: 'point',
      sizeField: 4,
      style: {
        fill: '#06D6A0',
      },
    },
    style: {
      lineWidth: 2,
      stroke: '#06D6A0',
    },
    tooltip: {
      marker: false,
      items: tooltipItems,
    },
    scale: {
      y: {
        domainMin: 0,
      },
    },
  };
  return (
    <div className='col-12 d-flex gap-2 flex-lg-nowrap flex-wrap pb-1 px-1'>
      <div className={`${includeCard ? 'col-12 col-lg-8' : 'col-12'} d-flex flex-column`}>
        {title !== null && (
          <div className='analytic-header-wrapper title ps-2 pt-2 pb-1'>
            <span className='analytic-title'>{title}</span>
          </div>
        )}
        <div className='line chart-height mw-100'>
          <div className=' h-100 w-100 mw-100 mh-100'>
            <Line {...config} />
          </div>
        </div>
      </div>
      {includeCard && (
        <div className='col-12 col-lg-4'>
          <StatisticsCard
            className=''
            includeShadow={false}
            isFromChart={true}
            data={additionalData}
          />
        </div>
      )}
    </div>
  );
}
export default CustomLineChart;
